/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
// import "@google/model-viewer";
import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
    fabricAtom,
    loaderAtom,
    modelAtom,
    beforeSelectedImageScaletom,
    uploadImageAtom,
    modelViewerSettingAtom,
} from "../../state";
import { ImageGlobalUrl } from "../../lib/constant";

const textures = {};

const PillowModelViewer = () => {
    const fabric = useRecoilValue(fabricAtom);
    const uploadImage = useRecoilValue(uploadImageAtom)
    const [modelViewer, setModelViewer] = useState(document.querySelector("#model-viewer"))
    const [modelAtomValue, setModelAtomValue] = useRecoilState(modelAtom);
    const [, setLoader] = useRecoilState(loaderAtom)
    const inputSetValue = useRecoilValue(beforeSelectedImageScaletom);
    const modelViewerSetting = useRecoilValue(modelViewerSettingAtom)

    useEffect(() => {
        const intervalId = setInterval(() => {
            setModelViewer(document.querySelector("#model-viewer"))
        }, 1000);
        // Cancel the interval after 5 seconds (5000 milliseconds)
        setTimeout(() => {
            clearInterval(intervalId);
        }, 1000);
        setLoader(true)
    }, []);

    useEffect(() => {
        if (modelViewer) {
            updateMaterial();
        }
    }, [fabric?.partWiseFabric, modelAtomValue, uploadImage, modelViewer]);

    useEffect(() => {
        if (uploadImage) {
            Object.entries(uploadImage).forEach(([key, value]) => {
                createTextureImages(key, value);
            });
        }
    }, [modelAtomValue, modelViewer, uploadImage]);

    // custom fabric apply at that time apply uv model
    useEffect(() => {
        (async () => {
            setTimeout(async () => {
                await getUVModel();
                await getImageUVModel();
            }, 1000);
        })();
    }, [fabric?.partWiseFabric, modelViewer, modelAtomValue, inputSetValue]);

    const checkImageDataURL = (imageURL) => {
        const dataRegEx =
            /^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*.+;=\-._~:@/?%\s]*\s*$/i;
        return !!(
            imageURL &&
            typeof imageURL === "string" &&
            imageURL.match(dataRegEx)
        );
    };

    const checkImageDataBLOB = (imageURL) =>
        !!(imageURL && typeof imageURL === "string" && imageURL.includes("blob:"));

    const updateImageURL = (imageURL) => {
        if (!imageURL || typeof imageURL !== "string") return undefined;

        if (checkImageDataURL(imageURL) || checkImageDataBLOB(imageURL))
            return imageURL;

        if (!imageURL.includes("http")) {
            return `${process.env.NEXT_PUBLIC_CLOUD_FRONT_URL}${imageURL}`;
        }

        return imageURL;
    };
    useEffect(() => {
        const modelViewer = document.querySelector("#model-viewer");
        if (modelViewer) {
            const defaultModelViewerSettings = modelViewerSetting
            if (defaultModelViewerSettings?.interpolationDecay) {
                modelViewer.setAttribute('interpolation-decay', defaultModelViewerSettings.interpolationDecay);
            }
            if (defaultModelViewerSettings?.disablePan) {
                modelViewer.setAttribute('disable-pan', defaultModelViewerSettings.disablePan);
            }

            if (defaultModelViewerSettings?.exposure) {
                modelViewer.setAttribute('exposure', defaultModelViewerSettings.exposure);
            }

            if (defaultModelViewerSettings?.maxCameraOrbit) {
                modelViewer.setAttribute('max-camera-orbit', defaultModelViewerSettings.maxCameraOrbit);
            }

            if (defaultModelViewerSettings?.minCameraOrbit) {
                modelViewer.setAttribute('min-camera-orbit', defaultModelViewerSettings.minCameraOrbit);
            }

            if (defaultModelViewerSettings?.selectedToneMapping) {
                modelViewer.setAttribute('tone-mapping', defaultModelViewerSettings.selectedToneMapping);
            }

            if (defaultModelViewerSettings?.cameraOrbit) {
                modelViewer.removeAttribute('camera-orbit');
            }

            if (defaultModelViewerSettings?.cameraTarget) {
                modelViewer.removeAttribute('camera-target');
            }
            if (defaultModelViewerSettings?.disableZoom) {
                modelViewer.setAttribute('disable-zoom', '');
            } else {
                modelViewer.removeAttribute('disable-zoom');
            }

            if (!defaultModelViewerSettings?.disableTap) {
                modelViewer.setAttribute('disable-tab', '');
            } else {
                modelViewer.setAttribute('disable-tab', defaultModelViewerSettings.disableTap);
            }

            if (defaultModelViewerSettings?.shadowIntensity) {
                modelViewer.setAttribute(
                    'shadow-intensity',
                    defaultModelViewerSettings.shadowIntensity,
                );
            } else {
                modelViewer.setAttribute(
                    'shadow-intensity',
                    '1',
                );
            }

            const envImg = updateImageURL(defaultModelViewerSettings?.environmentImage);
            if (defaultModelViewerSettings?.environmentImage || envImg) {
                modelViewer.setAttribute('environment-image', envImg || '');
            }

            if (defaultModelViewerSettings?.legacyenvironmentimagebasedlighting) {
                modelViewer.setAttribute(
                    'environment-image',
                    updateImageURL(
                        defaultModelViewerSettings?.style?.envMap ||
                        envImg ||
                        `${defaultModelViewerSettings?.style?.companyId || ''}/environment/env.jpeg`, // Fallback for companyId
                    ) || '' // Ensure a string is passed to updateImageURL
                );
            } else {
                modelViewer.setAttribute('environment-image', '');
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modelViewerSetting, modelViewer]);
    const getUVModel = async () => {
        try {
            if (modelViewer?.model) {

                const model = modelViewer.model;
                let keys = [
                    ...(fabric?.partWiseFabric && Object.keys(fabric?.partWiseFabric).length > 0
                        ? Object.keys(fabric?.partWiseFabric)
                        : []),
                    ...(uploadImage && Object.keys(uploadImage).length > 0
                        ? Object.keys(uploadImage)
                        : []),
                ];

                if (!model || !keys?.length) return;
                const parts = model[Object.getOwnPropertySymbols(model)[1]];
                let meterialIndexies = [];

                for (const key of keys) {
                    // eslint-disable-next-line no-loop-func
                    parts.forEach((part) => {
                        if (key === part.name) {
                            // const index = part.initialMaterialIdx
                            const index = part.initialMaterialIdx;
                            meterialIndexies = {
                                ...meterialIndexies,
                                [key]: index,
                            };
                        }
                    });
                }

                for (const fabricKey of keys) {
                    if (typeof meterialIndexies[fabricKey] === 'number' && isFinite(meterialIndexies[fabricKey])) {
                        const material = modelViewer.model.materials[meterialIndexies[fabricKey]];
                        const diffuse_map = material?.pbrMetallicRoughness?.['baseColorTexture']?.texture?.sampler;
                        const normal_map = material?.normalTexture?.texture?.sampler;
                        if (fabricKey) {
                            const scale = {
                                u: inputSetValue?.[fabricKey]?.Scale || 1,
                                v: inputSetValue?.[fabricKey]?.Scale || 1,
                            };
                            diffuse_map?.setScale(scale);
                            normal_map?.setScale(scale);
                        }
                    }
                }
            }
        } catch (error) {
            console.log("🚀 ~ error file: PillowModelViewer.js:248 ~ getUVModel ~ error:", error)
        }
    };
    const getImageUVModel = async () => {
        try {
            if (modelViewer?.model) {

                const model = modelViewer.model;
                let keys = (uploadImage && Object.keys(uploadImage)) || [];

                if (!model || !keys?.length) return;

                const parts = model[Object.getOwnPropertySymbols(model)[1]];
                let meterialIndexies = [];

                for (const key of keys) {
                    // eslint-disable-next-line no-loop-func
                    parts.forEach((part) => {
                        if (key === part.name) {
                            const index = part.initialMaterialIdx;
                            meterialIndexies = {
                                ...meterialIndexies,
                                [key]: index,
                            };
                        }
                    });
                }
                for (const fabricKey of keys) {
                    if (typeof meterialIndexies[fabricKey] === 'number' && isFinite(meterialIndexies[fabricKey])) {
                        const material = modelViewer?.model?.materials?.[meterialIndexies?.[fabricKey]];
                        const diffuse_map = material?.pbrMetallicRoughness?.['baseColorTexture']?.texture?.sampler;
                        const normal_map = material?.normalTexture?.texture?.sampler;
                        if (fabricKey) {
                            const scale = {
                                u: inputSetValue?.[fabricKey]?.Scale || 1,
                                v: inputSetValue?.[fabricKey]?.Scale || 1,
                            };
                            diffuse_map?.setScale(scale);
                            normal_map?.setScale(scale);
                        }

                    }
                }
            }
        } catch (error) {
        }
    };

    const createAndApplyTextureImage = async (channel, path, keys) => {
        if (modelViewer?.model) {
            var texture = await modelViewer.createTexture(path);
            const model = modelViewer.model;
            const parts = model[Object.getOwnPropertySymbols(model)[1]];
            const meterialIndexies = [];
            const partWiseIndex = {};

            parts.forEach((part) => {
                const index = part.initialMaterialIdx
                if (index || index == 0) {
                    partWiseIndex[index] = part.name;
                    if (keys?.includes(part.name)) {
                        meterialIndexies.push(index);
                    }
                }
            });

            meterialIndexies.forEach((index) => {
                const material = modelViewer?.model?.materials?.[index];
                if (channel.includes("base") || channel.includes("metallic")) {
                    material?.pbrMetallicRoughness?.[channel]?.setTexture(null);
                    material?.pbrMetallicRoughness?.[channel]?.setTexture(texture);
                } else {
                    material[channel]?.setTexture(null);
                    material[channel].setTexture(texture);
                }
            });
        }
    }

    const createAndApplyTexture = async (channel, modelPartName, fabricImg) => {
        const base64Image = fabricImg?.search('data:image/png;base64') !== -1 ? true : false
        let imageConvert = fabricImg

        try {
            if (modelViewer?.model) {
                let texture = null;
                if (fabricImg) {
                    if (textures[fabricImg]) {
                        texture = textures[fabricImg];
                    } else {
                        texture = await modelViewer.createTexture(base64Image ? fabricImg : `${ImageGlobalUrl}/${imageConvert}`);
                        textures[fabricImg] = texture;
                    }
                }

                const model = modelViewer.model;
                const parts = model[Object.getOwnPropertySymbols(model)[1]];

                const meterialIndexies = [];
                const partWiseIndex = {};

                parts.forEach((part) => {
                    const index = part.initialMaterialIdx;
                    partWiseIndex[index] = index;
                    if (modelPartName === part.name) {
                        meterialIndexies.push(index);
                    }

                });

                meterialIndexies.forEach((index) => {
                    const material = modelViewer.model.materials[index];

                    if (fabricImg) {
                        if (channel.includes("base") || channel.includes("metallic")) {
                            material.pbrMetallicRoughness[channel].setTexture(null);
                            material.pbrMetallicRoughness[channel].setTexture(texture);
                        } else {
                            material[channel]?.setTexture(null);
                            material[channel].setTexture(texture);
                        }
                    } else {
                        material[channel]?.setTexture(null);
                    }

                });
            }
        } catch (err) {
            console.error(err);
        }
    };
    const updateMaterial = async () => {
        let keys, material;

        if (!fabric.partWiseFabric) {
            return;
        }

        keys = Object.keys(fabric.partWiseFabric) || [];

        material = fabric;

        if (keys?.length === 0) {
            return;
        }
        for (const key of keys) {
            if (material.partWiseFabric[key]) {
                await createAndApplyTexture(
                    "baseColorTexture",
                    key,
                    key === 'Fringe' ? material.partWiseFabric[key].alphaDiffuse : material.partWiseFabric[key].diffuse
                );
                await createAndApplyTexture(
                    "metallicRoughnessTexture",
                    key,
                    material.partWiseFabric[key].metallicRoughness
                );
                await createAndApplyTexture(
                    "normalTexture",
                    key,
                    material.partWiseFabric[key].normal
                );

            }
        }
    };

    const createTextureImages = (imageType, image) => {
        createAndApplyTextureImage('baseColorTexture', image, imageType);
        createAndApplyTextureImage('metallicRoughnessTexture', 'metalicRoughness.jpeg', imageType);
        createAndApplyTextureImage('normalTexture', 'normal.jpg', imageType);
    }

    document.querySelector("#model-viewer")?.addEventListener("progress", (event) => {
        if (event.detail.totalProgress === 1) {
            setModelAtomValue({
                ...modelAtomValue,
                loading: 100,
            })
            setLoader(false)
        }
    })


    const viewer = document.getElementById('model-viewer');
    // --- Page runtime tracking ---
    const pageStartTime = Date.now();

    // --- Model interaction tracking ---
    let interactionStarted = false;
    let interactionStartTime = null;
    let totalInteractionTime = 0;
    let interactionInterval = null;
    let hasLogged = false;

    function startInteractionTimer() {
        if (!interactionStarted) {
            interactionStarted = true;
            interactionStartTime = Date.now();
            console.log("🔄 Interaction started");
        }

        if (!interactionInterval) {
            interactionInterval = setInterval(() => {
                if (interactionStarted && interactionStartTime) {
                    const now = Date.now();
                    totalInteractionTime += now - interactionStartTime;
                    interactionStartTime = now;

                    const interactionSec = Math.round(totalInteractionTime / 1000);
                    console.log(`⏱ Model interaction time: ${interactionSec} seconds`);
                }
            }, 1000);
        }
    }

    function stopInteractionTimer() {
        if (interactionStarted && interactionStartTime) {
            totalInteractionTime += Date.now() - interactionStartTime;
            interactionStartTime = null;
            interactionStarted = false;
            console.log("⏹ Interaction stopped");
        }
    }
    if (viewer) {
        // Start/stop tracking
        viewer.addEventListener('mousedown', startInteractionTimer);
        viewer.addEventListener('touchstart', startInteractionTimer);
        viewer.addEventListener('mouseup', stopInteractionTimer);
        viewer.addEventListener('touchend', stopInteractionTimer);
        viewer.addEventListener('mouseleave', stopInteractionTimer);
    }


    // On page unload: log total runtime and interaction time
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden' && !hasLogged) {
            stopInteractionTimer();

            const pageRuntime = Math.round((Date.now() - pageStartTime) / 1000);
            const interactionTime = Math.round(totalInteractionTime / 1000);

            console.log(`🕒 Total page runtime: ${pageRuntime} seconds`);
            console.log(`📤 Final model interaction time: ${interactionTime} seconds`);

            gtag('event', 'User_Page_Spend_Time', {
                event_category: '3D Viewer',
                event_label: 'Total time on page',
                value: pageRuntime
            });

            gtag('event', '3D_Viewer_User_Spend_Time', {
                event_category: '3D Viewer',
                event_label: 'Total interaction time with model',
                value: interactionTime
            });

            hasLogged = true;
        }
    });

    if (modelAtomValue.src) {
        return (
            <div className="relative">
                <div id="card"
                    className="opacity-100 transition-opacity duration-1000 ease-in-out h-[57vh] w-full">
                    <model-viewer
                        tone-mapping="commerce"
                        src={modelAtomValue.src}
                        camera-controls
                        disable-pan
                        ar
                        style={{ height: "57vh", width: "100%" }}
                        id="model-viewer"
                        exposure="0.8"
                    ></model-viewer>
                </div>
            </div>
        )
    } else {
        return <></>
    }
}

export default PillowModelViewer